import _ from 'lodash'

export const Enums = {
  apply (value, enumModel) {
    return (value && _.find(enumModel.values, v => v === value || v.id === value || v.id === value.id)) || value
  },
  extend (value, enumModel) {
    const model = Enums.apply(value, enumModel)
    return model && Object.assign(value, model)
  },
  value (id, labelKey, options) {
    return Object.assign({ id: id, labelKey: labelKey || id }, options)
  },
  create (id, values) {
    return {
      id: id,
      values: values
    }
  }
}

export const Entities = {
  asUpdate (entity) {
    return entity && (entity.asUpdate ? entity.asUpdate() : entity)
  },
  addReference (result, source, propertyName) {
    if (_.isArray(propertyName)) {
      _.each(propertyName, p => Entities.addReference(result, source, p))
    } else {
      const value = source[propertyName]
      if (value && value.id) {
        result[`${propertyName}_id`] = value.id
      }
    }
    return result
  },
  areEqual (first, second) {
    return first && second && (first.id === second.id || first === second)
  },
  areAllEqual (first, second) {
    return first && second && _.size(first) === _.size(second) && _.every(first, (f, index) => Entities.areEqual(f, second[index]))
  },
  hasId (entity, id) {
    if (entity) {
      const normalizedId = _.isNumber(entity.id) ? parseInt(id) : id
      return entity.id === normalizedId
    }
    return false
  },
  items (page) {
    return _.isArray(page) ? page : page && page.items
  },
  getOverflow (page) {
    return _.isArray(page) ? 0 : page.total_count - _.size(page.items)
  }
}

export const Actions = {
  create (id, labelKey, icon, options) {
    return Enums.value(id, labelKey, Object.assign({ icon: icon }, options))
  }
}
